import React from "react";
import { ArrowRight, Check } from "lucide-react";
import { Prices } from "../enums/prices";
import { checkout } from "../api/stripe/stripe";
export default function PricingCard({ title, price, period, description, features, isFeatured, buttonText, isCurrent, plantype }) {
  // Determine background color based on plan type
  const getBackgroundClass = () => {
    if (isFeatured) return "bg-blue-600 transform scale-105";
    if (title === "Free Plan" || title === "Basic Plan") return "bg-gray-50 border-gray-200";
    return "bg-white border-gray-100";
  };

  const handleButtonClick = async (e) => {
    if (isCurrent) return;
    console.log(plantype)
    console.log(period)
    if (plantype === 'free') {
      period = "/week";
    }
    console.log("periodTime", period.slice(1).toLowerCase());
    const results = await checkout({ plantype: plantype, periodTime: period.slice(1).toLowerCase() });
    window.open(results.url, '_blank');

    return;


  };

  return (
    <div
      className={`rounded-xl p-6 shadow-lg border relative transition-transform duration-300 ease-in-out hover:-translate-y-1 ${getBackgroundClass()}`}
    >
      {isFeatured && (
        <div className="absolute -top-3 left-1/2 transform -translate-x-1/2">
          <span className="bg-blue-500 text-white px-3 py-1 rounded-full text-xs font-medium">
            Most popular
          </span>
        </div>
      )}
      {isCurrent && (
        <div className="absolute -top-3 left-1/2 transform -translate-x-1/2">
          <span className="bg-green-500 text-white px-3 py-1 rounded-full text-xs font-medium">
            Current Plan
          </span>
        </div>
      )}
      <div className="mb-4">
        <h3 className={`text-lg font-semibold mb-2 ${isFeatured ? "text-white" : "text-gray-900"}`}>
          {title}
        </h3>
        <div className="mb-2">
          <span className={`text-3xl font-bold ${isFeatured ? "text-white" : "text-gray-900"}`}>
            {price}
          </span>
          {period && (
            <span className={`text-sm ml-2 ${isFeatured ? "text-blue-200" : "text-gray-500"}`}>
              {period}
            </span>
          )}
        </div>
        <p className={`text-sm ${isFeatured ? "text-blue-200" : "text-gray-600"}`}>
          {description}
        </p>
      </div>
      <div className="mb-6">
        {features.map((feature, index) => (
          <div key={index} className="flex items-center mb-2">
            <Check className={`w-4 h-4 mr-2 ${isFeatured ? "text-white" : "text-blue-500"}`} />
            <span className={`text-sm ${isFeatured ? "text-white" : "text-gray-700"}`}>
              {feature}
            </span>
          </div>
        ))}
      </div>
      <button
        onClick={handleButtonClick}
        className={`w-full py-2 px-4 rounded-lg font-semibold text-sm flex items-center justify-center ${isCurrent
          ? "bg-gray-300 text-gray-600 cursor-not-allowed"
          : isFeatured
            ? "bg-white text-blue-600 hover:bg-gray-50"
            : "bg-white border-2 border-blue-500 text-blue-500 hover:bg-blue-50"
          } transition-colors`}
        disabled={isCurrent}
      >
        {buttonText}
        {!isCurrent && <ArrowRight className="w-4 h-4 ml-2" />}
      </button>
    </div>
  );
}